import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type ArtworkFrameProps = {
    className?: string;
};

const ArtworkFrame: FunctionComponent<ArtworkFrameProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'artwork-frame'}
            viewBox="0 0 250 250"
        >
            <path d="M138.252 21.357L180.566 69H250v178H0V69h70.434l43.05-48.472A13.01 13.01 0 0 1 113 17c0-7.18 5.82-13 13-13s13 5.82 13 13a12.99 12.99 0 0 1-.748 4.357zm-5.938 7.01A12.941 12.941 0 0 1 126 30c-2.291 0-4.445-.593-6.314-1.634L84 70h84l-35.686-41.634zM21 90v135h208V90H21z" />
        </svg>
    );
};
export default ArtworkFrame;
